import React from 'react';

import { FormikCheckbox } from '~commonInfra/components/FormikCheckbox';
import { MetadataDrivenSiteSettings } from '~src/commonInfra/components/MetadataDrivenSiteSetting';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';

import { Messages } from '../../../../../codegen/Localize';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '../../site-settings/ReactSiteSettingsForSiteAdmin';

export const REMOVE_SUBSCRIPTION_AND_DDA_EMAIL_LINKS_FIELD = 'settings.subscriptionAndDDAEmailLinksEnabled';
export const NOTIFICATION_EMAIL_SETTINGS_SECTION_TEST_ID = 'notification-email-settings-section';
export const REMOVE_SUBSCRIPTION_AND_DDA_EMAIL_LINKS_CHECKBOX_TEST_ID = 'remove-subscription-and-dda-email-links-enabled';
export const NOTIFICATION_EMAIL_SETTINGS_SECTION_NAME = 'subscriptionAndDDAEmailLinksEnabled';
export const NOTIFICATION_EMAIL_SETTINGS_PREFIX = 'settings';

export type NotificationEmailSettingsSectionProps = SiteSettingsForSiteAdminProps<'subscriptionAndDDAEmailLinksEnabled'>;

export function NotificationEmailSettingsSection(props: NotificationEmailSettingsSectionProps): React.ReactElement {
  if (FeatureFlags.metadataDrivenSiteSettingsEnabled) {
    return (
    <SettingsSection
      title={Messages.notificationEmailSettingsTitle()}
      testId={NOTIFICATION_EMAIL_SETTINGS_SECTION_TEST_ID}>
        <MetadataDrivenSiteSettings
          sectionName={NOTIFICATION_EMAIL_SETTINGS_SECTION_NAME}
          formikPrefix={NOTIFICATION_EMAIL_SETTINGS_PREFIX} />
    </SettingsSection>
    );
  }

  return (
    <SettingsSection
      description={Messages.notificationEmailSettingsDescription()}
      title={Messages.notificationEmailSettingsTitle()}
      testId={NOTIFICATION_EMAIL_SETTINGS_SECTION_TEST_ID}>
      <FormikCheckbox
        label={Messages.removeSubscriptionAndDDAEmailLinksDescription()}
        name={REMOVE_SUBSCRIPTION_AND_DDA_EMAIL_LINKS_FIELD}
        testId={REMOVE_SUBSCRIPTION_AND_DDA_EMAIL_LINKS_CHECKBOX_TEST_ID} />
    </SettingsSection>
  );
}

export const NotificationEmailSettingsSectionSpecs = componentRegistryEntry({
  name: 'NotificationEmailSettingsSection',
  component: NotificationEmailSettingsSection
});
